/**
=========================================================
* Otis Admin PRO - v2.0.2
=========================================================

* Product Page: https://material-ui.com/store/items/otis-admin-pro-material-dashboard-react/
* Copyright 2024 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

/** 
  All of the routes for the Otis Admin PRO React are added here,
  You can add a new route, customize the routes and delete the routes here.

  Once you add a new route on this file it will be visible automatically on
  the Sidenav.

  For adding a new route you can follow the existing routes in the routes array.
  1. The `type` key with the `collapse` value is used for a route.
  2. The `type` key with the `title` value is used for a title inside the Sidenav. 
  3. The `type` key with the `divider` value is used for a divider between Sidenav items.
  4. The `name` key is used for the name of the route on the Sidenav.
  5. The `key` key is used for the key of the route (It will help you with the key prop inside a loop).
  6. The `icon` key is used for the icon of the route on the Sidenav, you have to add a node.
  7. The `collapse` key is used for making a collapsible item on the Sidenav that contains other routes
  inside (nested routes), you need to pass the nested routes inside an array as a value for the `collapse` key.
  8. The `route` key is used to store the route location which is used for the react router.
  9. The `href` key is used to store the external links location.
  10. The `title` key is only for the item with the type of `title` and its used for the title text on the Sidenav.
  10. The `component` key is used to store the component of its route.
*/

// Otis Admin PRO React layouts
import Analytics from "layouts/dashboards/analytics";
import ProfileOverview from "layouts/pages/profile/profile-overview";
import Settings from "layouts/pages/account/settings";
import SignInBasic from "layouts/authentication/sign-in/basic";

// @mui icons
import Icon from "@mui/material/Icon";

// Images
import LandingLayout from "layouts/landing";
import DashboardAffiliatePage from "layouts/dashboards/analytics";
import AuthWrapper from "auth/AuthWrapper";
import IllustrationLayout from "layouts/authentication/sign-in/illustration";
import Logout from "layouts/authentication/sign-in/illustration/logout";
import PricingPage from "layouts/register/pricing-page";

import RegisterSuccess from "layouts/register/pricing-page/RegisterSuccess";
import RegisterCancel from "layouts/register/pricing-page/RegisterCancel";
import AffiliateResetPassword from "layouts/register/pricing-page/affiliateResetPassword";
import ForgotPassword from "layouts/authentication/forgot-password";
import ClientEditProfile from "layouts/Info";
import ClientGalleryPage from "layouts/gallery";
import AdminInterestsPage from "layouts/interests";
import ProfileAccountPage from "layouts/Account";
import BillingPage from "layouts/pages/account/billing";
import ProfileSupportPage from "layouts/Support";
import ProfileFaqPage from "layouts/faq";
import EventRequestsPage from "layouts/eventRequests";
import MyOffersPage from "layouts/myOffers";

const routes = [
  {
    type: "single",
    name: "nav.stats",
    key: "stats",
    icon: <Icon fontSize="medium">percentage</Icon>,
    route: "/pages/analytics",
    component: <AuthWrapper><DashboardAffiliatePage /></AuthWrapper>,
    noCollapse: true,
  },
  {
    type: "single",
    name: "nav.info",
    key: "info",
    icon: <Icon fontSize="medium">info</Icon>,
    route: "/pages/profile/info",
    component: <AuthWrapper><ClientEditProfile /></AuthWrapper>,
    noCollapse: true,
  },
  {
    type: "single",
    name: "nav.gallery",
    key: "img",
    icon: <Icon fontSize="medium">images</Icon>,
    route: "/pages/profile/gallery",
    component: <AuthWrapper><ClientGalleryPage /></AuthWrapper>,
    noCollapse: true,
  },
  {
    type: "single",
    name: "nav.interests",
    key: "interests",
    icon: <Icon fontSize="medium">favorite</Icon>,
    route: "/pages/profile/interests",
    component: <AuthWrapper><AdminInterestsPage /></AuthWrapper>,
    noCollapse: true,
  },
  {
    type: "single",
    name: "nav.eventRequests",
    key: "event-requests",
    icon: <Icon fontSize="medium">event_note</Icon>,
    route: "/pages/event-requests",
    component: <AuthWrapper><EventRequestsPage /></AuthWrapper>,
    noCollapse: true,
  },
  {
    type: "hidden",
    key: "my-offers",
    route: "/pages/my-offers",
    component: <AuthWrapper><MyOffersPage /></AuthWrapper>,
  },
  {
    type: "single",
    name: "nav.account",
    key: "myaccount",
    icon: <Icon fontSize="medium">manage_accounts</Icon>,
    route: "/pages/profile/me",
    component: <AuthWrapper><ProfileAccountPage /></AuthWrapper>,
    noCollapse: true,
  },
  {
    type: "single",
    name: "nav.billing",
    key: "billing",
    icon: <Icon fontSize="medium">credit_card</Icon>,
    route: "/pages/account/billing",
    component: <AuthWrapper><BillingPage /></AuthWrapper>,
    noCollapse: true,
  },
  {
    type: "single",
    name: "nav.support",
    key: "support",
    icon: <Icon fontSize="medium">headset</Icon>,
    route: "/pages/support",
    component: <AuthWrapper><ProfileSupportPage /></AuthWrapper>,
    noCollapse: true,
  },
  {
    type: "single",
    name: "nav.faq",
    key: "faq",
    icon: <Icon fontSize="medium">question_answer</Icon>,
    route: "/pages/faq",
    component: <AuthWrapper><ProfileFaqPage /></AuthWrapper>,
    noCollapse: true,
  },
  // settings
  {
    type: "single",
    name: "nav.logout",
    key: "logout",
    icon: <Icon fontSize="medium">logout</Icon>,
    route: "/authentication/sign-in/basic",
    component: <Logout />,
    noCollapse: true,
  },
  // just links
  {
    route: "/authentication/sign-in",
    key: "signin",
    component: <IllustrationLayout />,
  },
  {
    route: "/authentication/register",
    key: "register",
    component: <PricingPage />,
  },
  {
    route: "/register/success",
    key: "register-success",
    component: <RegisterSuccess />,
  },
  {
    route: "/register/cancel",
    key: "register-cancel",
    component: <RegisterCancel />,
  },
  {
    route: "/authentication/reset-password",
    key: "affiliate-reset-password",
    component: <AffiliateResetPassword />,
  },
  {
    route: "/authentication/forgot-password",
    key: "forgot-password",
    component: <ForgotPassword />,
  },
];

export default routes;
